import React, { useEffect, useState, memo } from "react";
import PharmacyServicesPanel from "../../PharmacyServicesPanel/PharmacyServicesPanel";
import ClinicalChecksKanban from "../../../pages/Dashboard/ServicesTab/ServicesContainer/ClinicalChecksKanban/ClinicalChecksKanban";
import useTitanApp from "../../../hooks/useTitanApp";
import SchedulerComponent from "../../Scheduler/Schedule";
import PatientList from "../../PatientConsultation/components/PatientList/PatientList";
import ScheduleCalendar from "../../../components/Calendar/Schedule";
import { PrescriptionApproval } from "../../../components/PrescriptionApproval/PrescriptionApproval";
import Dashboard from "../../PharmacyDashboard/Dashboard";
import Documents from "../../Documents/Documents";
import DocumentSession from "../../Documents/DocumentSession";
import Analytics from "../../Analytics/Analytics";
import TitanScreen from "../../TitanScreen/TitanScreen";

function GlobalTabbedContent({}) {
  const { appState } = useTitanApp();
  const { globalTabText, features, darkMode } = appState || {};
  const { ifKanbanSearchBoxEnabled, ifNewCalendar } = features || {};
  const [prescriptions, setPrescriptions] = useState([]);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [docSession, setDocSession] = useState(null);
  const [currentDocumentScreen, setCurrentDocumentScreen] =
    useState("Documents");

  return (
    <div className="main-content">
      {(globalTabText === "PharmacyDashboard" ||
        globalTabText === "Dashboard") && <Dashboard />}

      {globalTabText === "Services" && <PharmacyServicesPanel />}
      {globalTabText === "Calendar" && (
        ifNewCalendar ? <ScheduleCalendar /> : <SchedulerComponent />
      )}
      {globalTabText === "Clinical Checks" && <ClinicalChecksKanban />}
      {globalTabText === "Approvals" && (
        <PrescriptionApproval
          isDarkMode={isDarkMode}
          prescriptions={prescriptions}
          setPrescriptions={setPrescriptions}
        />
      )}
      {ifKanbanSearchBoxEnabled === true && globalTabText === "Patients" && (
        <PatientList />
      )}
      {globalTabText === "Documents" &&
        (currentDocumentScreen === "Documents" ? (
          <Documents
            onStartSession={(docs, initialId) => {
              setDocSession({ docs, initialId });
              setCurrentDocumentScreen("documentSession");
            }}
          />
        ) : currentDocumentScreen === "documentSession" && docSession ? (
          <DocumentSession
            docs={docSession.docs}
            initialId={docSession.initialId}
            setCurrentDocumentScreen={setCurrentDocumentScreen}
          />
        ) : null)}
      {globalTabText === "Analytics" && <Analytics isDarkMode={darkMode} />}
      {globalTabText === "Business" && <TitanScreen isDarkMode={darkMode} />}
      {/* {globalTab === 0 && <h3>Content for Tab Three</h3>} */}
    </div>
  );
}

export default memo(GlobalTabbedContent);
